import { Fragment, FunctionComponent } from 'react';
import Pagination from '../../shared/Pagination';
import { Table, TableHead, TableHeader } from '../../shared/Table';
import { usePagination } from '../../shared/usePagination';
import { PinboardMessage } from '../models/GetPinboardMessagesResponse';
import PinboardMessageItem from './PinboardMessageItem';

type Props = {
    messages: PinboardMessage[];
};

const PinboardMessageList: FunctionComponent<Props> = ({ messages }) => {
    const { currentPage, setCurrentPage, currentItems, totalPages, itemsPerPage } = usePagination(messages);

    return (
        <Fragment>
            <Table withPagination={totalPages > 1}>
                <TableHead>
                    <tr>
                        <TableHeader>Fastnålat</TableHeader>
                        <TableHeader>Rubrik</TableHeader>
                        <TableHeader>Kan svara</TableHeader>
                        <TableHeader>Publiceringsdatum</TableHeader>
                        <TableHeader>Avpubliceras</TableHeader>
                    </tr>
                </TableHead>
                <tbody>
                    {currentItems.map((item) => (
                        <PinboardMessageItem key={item.pinboardMessageId} {...item} />
                    ))}
                </tbody>
            </Table>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={messages.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
                ariaLabel="Meddelandelistans sidnavigering"
            />
        </Fragment>
    );
};

export default PinboardMessageList;
